"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableSizes = exports.sizes = void 0;

var _displayIcons = _interopRequireDefault(require("../lib/build/svg/display-icons.json"));

var _iconsActions = _interopRequireDefault(require("../lib/build/svg/icons--actions.json"));

var _iconsAv = _interopRequireDefault(require("../lib/build/svg/icons--av.json"));

var _iconsMiscellaneous = _interopRequireDefault(require("../lib/build/svg/icons--miscellaneous.json"));

var _iconsNavigation = _interopRequireDefault(require("../lib/build/svg/icons--navigation.json"));

var _iconsSocial = _interopRequireDefault(require("../lib/build/svg/icons--social.json"));

var _iconsUtility = _interopRequireDefault(require("../lib/build/svg/icons--utility.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var sizes = Object.freeze({
  INHERIT: "inherit",
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
});
exports.sizes = sizes;
var availableSizes = Object.freeze(Object.values(sizes));
exports.availableSizes = availableSizes;
var availableIds = [].concat(_toConsumableArray(_displayIcons.default), _toConsumableArray(_iconsActions.default), _toConsumableArray(_iconsAv.default), _toConsumableArray(_iconsMiscellaneous.default), _toConsumableArray(_iconsNavigation.default), _toConsumableArray(_iconsSocial.default), _toConsumableArray(_iconsUtility.default)).map(function (icon) {
  return icon.id;
});
var componentArgs = {
  className: {
    table: {
      disable: true
    }
  },
  children: {
    table: {
      disable: true
    }
  },
  id: {
    control: {
      type: "select"
    },
    options: availableIds
  },
  size: {
    control: {
      type: "select"
    },
    options: availableSizes
  }
};
exports.componentArgs = componentArgs;